import { gql } from '@apollo/client'

export const DELETE_TEST_SESSION = gql`
  mutation DeleteTestSession($id: ID!){
    deleteTestSession(id:$id)
  }
`
